interface StepIndicatorProps {
  /** Step labels; the active step's label is shown to the right of the circles. */
  steps: string[];
  /** 0-based index of the active step. */
  current: number;
  className?: string;
}

/**
 * Shared Brand → Campaign → Generate progress stepper.
 * Numbered circles with connectors + the active step's label — the canonical
 * onboarding treatment, reused across the onboarding wizard and brand creation.
 */
export default function StepIndicator({
  steps,
  current,
  className = "",
}: StepIndicatorProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {steps.map((label, i) => (
        <div key={label} className="flex items-center gap-3">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center text-base font-extrabold ${
              i === current
                ? "bg-brand-500 text-white"
                : i < current
                  ? "bg-brand-200 text-brand-700"
                  : "bg-gray-200 text-muted"
            }`}
          >
            {i + 1}
          </div>
          {i < steps.length - 1 && <div className="h-0.5 w-11 bg-gray-200" />}
        </div>
      ))}
      <span className="ml-2 text-lg font-bold text-slate">
        {steps[current]}
      </span>
    </div>
  );
}
